import boConfirm from './confirmation';
import initialize from './pageInitializationStatus';

export default {boConfirm, initialize};


// WEBPACK FOOTER //
// ./src/app/actions/index.js